/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Text from 'solis/react/primitive/text';

import descriptor, { calculateCost } from 'solis/claude/action/descriptor/update.value';
import ActionCard from 'solis/claude/action/card';


const Cost = ({ colony, zone }) =>
{
  const cost = calculateCost(colony, zone);

  return <Text.Note>{'Costs ' + cost.currency + ' currency'}</Text.Note>;
};


// Children evaluate before ActionCard gates on availability, so they must tolerate a
// missing target zone.
export default ({ context }) =>
(
  <ActionCard label = 'Update zone value' descriptor = {descriptor} context = {context}>

    {context.zone !== null && <Cost colony = {context.colony} zone = {context.zone} />}

  </ActionCard>
);
